import {
  DataDrivenContentHandle,
  DataDrivenContentConnectionOptions,
} from './DataDrivenContentHandle';

/**
 * @public
 */
export type DataDrivenContentReceiveMessage = {
  resultName: string;
  rowCount: number;
  columns: {
    name: string;
    label: string;
    type: 'string' | 'number';
    usage: 'quantitative' | 'brush';
    aggregation?: string;
  }[];
  data: (string | number)[][];
};

/**
 * @public
 */
export type DataDrivenContentSendMessage = {
  resultName: string;
  selections: { row: number }[];
};

/**
 * @public
 */
export function registerDataDrivenContent(
  connectionOptions: DataDrivenContentConnectionOptions,
  onMessage: (message: DataDrivenContentReceiveMessage) => void
): DataDrivenContentHandle {
  return new DataDrivenContentHandle(connectionOptions, onMessage);
}
